import { supabaseClient } from '@auth-v2';

import { ANALYSIS_TYPES, withRetry } from '@core';
import { fetchSwingAnalysis, fetchSwingById } from '@data';
import { getActivityReportKey, getSwingKey, queryClient, updateSwingAnalysis, upsertSwingToActivity } from '@queries';

export type FullAnalysisAvailableMessage = {
    swing_uuid: string;
    activity_id: number;
    swing_id: number;
    analysis_id: number;
};

const RETRY_COUNT = 24;
const RETRY_DELAY_MS = 5_000;

export async function loadFullAnalysis(payload: FullAnalysisAvailableMessage, userId: string): Promise<void> {
    await withRetry(
        async () => {
            const { swing_id: swingId } = payload;
            const swing = await fetchSwingById(supabaseClient, swingId);
            if (!swing) {
                throw new Error('Failed to load full analysis');
            }

            queryClient.setQueryData(getSwingKey(swing.uuid), swing);
            queryClient.invalidateQueries({
                queryKey: getActivityReportKey(swing.activityId),
            });

            upsertSwingToActivity(swing.activityId, swing);

            const newSwingAnalysis = await fetchSwingAnalysis(supabaseClient, swing.uuid);
            if (!newSwingAnalysis.fullAnalysis) {
                throw new Error('Full analysis not yet available');
            }

            updateSwingAnalysis(userId, swing.uuid, ANALYSIS_TYPES.FULL_ANALYSIS, newSwingAnalysis.fullAnalysis);
        },
        RETRY_COUNT,
        RETRY_DELAY_MS,
    );
}
